import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import fcbLogo from "../assets/images/fcb-logo.png";

export function PageClosed() {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const w = window as any;
        const hide = () => {
            try {
                w.$crisp && w.$crisp.push(["do", "chat:hide"]);
            } catch {}
        };
        hide();
        const interval = setInterval(hide, 500);
        const timeout = setTimeout(() => clearInterval(interval), 8000);
        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div
            style={{
                minHeight: "100vh",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "24px 16px",
                textAlign: "center",
                fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
                color: "#1a2238",
                background:
                    "radial-gradient(1200px 600px at 20% 10%, #eaf1ff 0%, transparent 60%)," +
                    "radial-gradient(900px 500px at 85% 90%, #ffe6d2 0%, transparent 55%)," +
                    "linear-gradient(180deg, #ffffff 0%, #f6f8fb 100%)",
            }}
        >
            <Helmet>
                <title>Fast Car Bids - Under construction</title>
                <meta name="robots" content="NOINDEX,NOFOLLOW" />
            </Helmet>

            <div
                style={{
                    maxWidth: 560,
                    width: "100%",
                    padding: "32px 28px",
                    backgroundColor: "#ffffff",
                    borderRadius: 16,
                    boxShadow: "0 20px 60px rgba(20, 38, 76, 0.08), 0 2px 8px rgba(20, 38, 76, 0.04)",
                    border: "1px solid rgba(20, 38, 76, 0.06)",
                }}
            >
                <img
                    src={fcbLogo}
                    alt="Fast Car Bids"
                    style={{ maxWidth: 180, width: "55%", height: "auto", marginBottom: 24 }}
                />
                <h1
                    style={{
                        fontSize: "clamp(28px, 5vw, 44px)",
                        fontWeight: 700,
                        letterSpacing: 1.5,
                        margin: "0 0 8px",
                        lineHeight: 1.15,
                        textTransform: "uppercase",
                    }}
                >
                    Under construction
                </h1>
                <div style={{ width: 64, height: 3, backgroundColor: "#fa731e", margin: "16px auto", borderRadius: 2 }} />
                <h2
                    style={{
                        fontSize: "clamp(20px, 3.2vw, 26px)",
                        fontWeight: 500,
                        margin: "0 0 20px",
                        color: "#2b3f57",
                        opacity: 0.9,
                    }}
                >
                    Site en construction
                </h2>
                <p style={{ fontSize: 16, maxWidth: 480, margin: "0 auto", lineHeight: 1.7, color: "#2b3f57", opacity: 0.8 }}>
                    Thank you for your interest in Fast Car Bids.
                    <br />
                    Merci de votre intérêt pour Fast Car Bids.
                </p>
            </div>
        </div>
    );
}
